export const baseUnits = [
	{ value: 1, label: "g - cc" },
	{ value: 1000, label: "Kg - L" },
	{ value: 10000, label: "Tn - KL" },
];

export const baseFilterOrders = {
	page: 1,
	paginate: 10,
	order: "date_create_order",
	orderType: "desc",
	defaultUnitFilter: 1000,
	purchaseOrderFilter: "",
	purchaseClassFilter: "",
	purchaseStateFilter: "",
	dateFilter: "",
	dateToFilter: "",
};

export const table_head = [
	{
		name: "Razón Social",
		size: "7",
		order: "business_name",
	},
	{
		name: "Fecha Ingreso",
		size: "8",
		order: "date_create_order",
	},
	{
		name: "Distribuidor",
		size: "5",
		order: "dealer_name",
	},
	{
		name: "N° Orden",
		size: "8",
		order: "code_oc",
	},
	{
		name: "Estado",
		size: "5",
		order: "state_name",
	},
	{
		name: "Fecha Entrega",
		size: "8",
		order: "date_order",
	},
	{
		name: "%Recepción",
		size: "8",
		order: "",
	},
	{
		name: "Grupos Campos",
		size: "9",
		order: "estate_parent_name",
	},
	{
		name: "Campo",
		size: "9",
		order: "estate_name",
	},
	{
		name: "Cantidad Envases",
		size: "5",
		order: "quantity",
	},
	{
		name: "Costo Total",
		size: "10",
		order: "price_total",
	},
	{
		name: "Acción",
		size: "2",
		order: "",
	},
	{
		name: "Adjuntos",
		size: "3",
		order: "",
	},
	{
		name: "",
		size: "5",
		order: "",
	},
];
